/**
 * Open the DMP website in the browser.
 */
export const openDMP = (): void => {
    window.ipcRenderer.openInBrowser('https://www.dmp.fr/web/dmp/ps');
};
